





































import { Component, Mixins } from 'vue-property-decorator'
import * as ApiPath from '@/tcw/constant/ApiPath'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import { TcwAPIID } from '@/tcw/domain/types'
import Getsudo from '@/tcw/domain/Getsudo'
import { TCWBaseError } from '@/plugins/TCWBaseError'
import TcwGetsudoPicker from '@/components/common/TcwGetsudoPicker.vue'

@Component({
  components: {
    TcwLayoutBasicTemplate,
    TcwGetsudoPicker
  }
})
export default class ExportImport extends Mixins(BasePage) {
  protected userId: TcwAPIID = null
  protected type = 3
  protected getsudo: Getsudo | null = null
  protected nendo = 2020
  protected message = ''

  protected get nendoList(): number[] {
    return new Array(10).fill(1).map((v, i) => i + 2017)
  }

  protected mounted(): void {
    this.getsudo = Getsudo.now(this.shimebi)
  }

  protected exportCsv(): void {
    this.isLoading = true

    if (this.type === 1) {
      this.exportCsvAll()
    } else if (this.type === 2) {
      this.$tcw.message({
        type: 'error',
        message: '年度のエクスポートは未実装'
      })
    } else if (this.type === 3) {
      this.exportCsvGetsudo()
    }
  }
  protected async exportCsvAll(): Promise<void> {
    const path = ApiPath.Paths.Export.all
    try {
      const response = await this.getWebApi().call<string>(
        path,
        'POST',
        {},
        { responseType: 'blob' }
      )

      const url = URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'TCard_Excel.xlsm') //ここらへんは適当に設定する
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      this.$tcw.message({
        type: 'error',
        message: 'Exceファイルの取得に失敗しました'
      })
      if (e instanceof TCWBaseError) {
        this.message = `[${e.getErrorCode()}]${e.outputMessage()}`
      } else {
        this.message = `${e}`
      }
    } finally {
      this.isLoading = false
    }
  }
  protected async exportCsvGetsudo(): Promise<void> {
    if (this.getsudo === null) {
      this.$tcw.message({
        type: 'error',
        message: '月度が指定されていません'
      })
      return
    }
    try {
      const path = ApiPath.buildPath(ApiPath.Paths.Export.getsudo, {
        year: this.currentGetsudo.yearValue,
        month: this.getsudo.monthValue
      })
      const response = await this.getWebApi().callRaw<string>(
        path,
        'GET',
        {},
        { responseType: 'blob' }
      )

      let fileName = this.tcw.getDecodedFileNameFromHeader(response.headers)
      if (fileName === null) {
        fileName = '遅延証明書.zip'
      }
      this.tcw.execDownloadFile(fileName, response.data)
    } catch (e) {
      this.$tcw.message({
        type: 'error',
        message: 'Exceファイルの取得に失敗しました'
      })
      if (e instanceof TCWBaseError) {
        this.message = `[${e.getErrorCode()}]${e.outputMessage()}`
      } else {
        this.message = `${e}`
      }
    } finally {
      this.isLoading = false
    }
  }
}
